import { motion } from "motion/react";

import cn from "@utils/helpers/cn";
import getProps from "@utils/helpers/getProps";

const BASE_CLASS_NAMES = cn(`
  m-0
  text-center
  font-serif
  font-bold
  leading-normal
  subpixel-antialiased

  text-transparent
  bg-clip-text
  bg-gradient-to-b
  from-(--page-title-foreground-color)
  to-(--page-title-foreground-color2)
`);

const SIZE_CLASS_NAMES = {
  sm: `
    text-[2rem]
    md:text-[2.75rem]
  `,
  md: `
    text-[2.75rem]
    md:text-[3.25rem]
  `,
  lg: `
    text-[5rem]
    md:text-[7.5rem]
    italic
    leading-[1.1]
  `,
};

export default function PageTitle(props) {
  const {
    value,
    size = "md",
    className,
  } = props;

  const {
    hasDivider,
  } = getProps(props, {
    hasDivider: true,
  });

  const classNames = cn(BASE_CLASS_NAMES, SIZE_CLASS_NAMES[size]);

  /**************************************************************************************************/

  if (!value) return null;

  return (
    <div className={cn(className)}>
      <motion.div
        key="page-title"
        initial={{
          opacity: 0,
          scale: 0.8,
        }}
        animate={{
          opacity: 1,
          scale: 1.0,
        }}
        transition={{
          type: "spring",
          stiffness: 100,
          damping: 10,
          delay: 0.75,
        }}
        layout={true}
      >
        <motion.h1 className={classNames}>
          {value}
        </motion.h1>
      </motion.div>

      {hasDivider && (
        <motion.div
          key="page-title-divider"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.75,
            delay: 0.4,
            ease: "easeOut",
          }}
          layout={true}
        >
          <hr className="my-2" />
        </motion.div>
      )}
    </div>
  );
}
